export const SET_EVENTS_DATA = 'SET_EVENTS_DATA';
export const SET_UPDATE_SHORTLISTED_EVENT_DATA = 'SET_UPDATE_SHORTLISTED_EVENT_DATA';


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/events/mutation-types.ts